import { useState, useEffect } from 'react';
import { apiRequest } from './api';

export type MilestoneMetadata = Record<string, { startDate: string; endDate?: string }>;

/**
 * Custom hook to fetch milestones for a product
 * @param productId - The product ID to fetch milestones for
 * @returns The milestones metadata object
 */
export function useMilestones(productId: string | undefined): MilestoneMetadata {
  const [milestones, setMilestones] = useState<MilestoneMetadata>({});

  useEffect(() => {
    if (!productId) {
      setMilestones({});
      return;
    }

    const fetchMilestones = async () => {
      try {
        const apiUrl = `/api/milestones?productId=${encodeURIComponent(productId)}`;
        const data = await apiRequest<Array<{ name: string; startDate: string; endDate?: string }>>(
          apiUrl,
          {},
          { useAuth: true }
        );
        const milestoneMap: MilestoneMetadata = {};
        (Array.isArray(data) ? data : []).forEach(m => {
          milestoneMap[m.name] = { startDate: m.startDate, endDate: m.endDate };
        });
        setMilestones(milestoneMap);
      } catch (error) {
        console.error('Error fetching milestones:', error);
        setMilestones({});
      }
    };

    fetchMilestones();
  }, [productId]);

  return milestones;
}

